export class ModalConfig {
    constructor(type: "confirm" | "alert", header: string, body: string, focusReturn: any, cancelCallback: any, okCallback?: any, footer?: string, okText?: string, cancelText?: string) {
        switch (type.toLowerCase()) {
            case "ok":
            case "confirm": {
                this.type = "confirm";
                this.ok = okCallback;
            } break;
            case "warning":
            case "alert": {
                this.type = "alert";
            } break;
        }
        this.focusReturn = focusReturn;
        this.headerText = header;
        this.bodyText = body;
        this.cancel = cancelCallback;
        this.okText = okText;
        this.cancelText = cancelText;
        this.footer = footer;
    }

    static CONFIRM: string = "confirm"
    static ALERT: string = "alert";

    type: "confirm" | "alert";
    focusReturn: any;
    headerText: string;
    bodyText: string;
    cancel: any;
    ok?: any;
    okText?: string;
    cancelText?: string;
    footer?: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/ModalConfig.ts